// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"7e88d285","82":"ac4bdf8e","247":"95b8af82","358":"0ed8fc19","422":"b9da4f1f","615":"064c5fdc","627":"4f4f2540","653":"614cd740","867":"bd4936c3","923":"22913a24","938":"2564637b"}[chunkId] + ".chunk.js";
};